module.exports = __webpack_public_path__ + "static/images/origin.2PdHTC7.svg";